import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const addBorrower = async() => {
    try {
        const data = JSON.stringify({
          svc: "loandisk",
          pid: "LoanDiskAddBorrower",
          dat: {},
        });
    
        const config = {
          method: "post",
          url: BACKEND_URL,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
    
        const response = await axios(config);
        console.log(response);
    
        return response.data;
      } catch (error) {
        console.log(error);
      }
};

export const createLoan = async() => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "LoanDiskAddNewLoan",
        dat: {},
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

/*
LoanDisk system uses their own internal ID called 'Unique Number'
We connect our users into the loandisk system using 
*/
export const getBorrower = async(userid) => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "LoanDiskAddBorrower",
        dat: {userid: userid},
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const getAllLoansFromBorrower = async(userid, pageNumber) => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "LoanDiskFetchAllLoanByBorrower",
        dat: {
          userid: userid,
          pageNumber: pageNumber
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const getLoan = async(userid, loanID) => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "LoanDiskFetchSingleLoan",
        dat: {
          userid: userid,
          loanID: loanID
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const getLoanRepayments = async(loanID, pageNumber) => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "LoanDiskFetchAllRepaymentsOfLoan",
        dat: {
          loanID: loanID,
          pageNumber: pageNumber
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const createLoanPayment = async(userid, amount, loanID, pin, agentid) => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "LoanDiskAddLoanRepayment",
        dat: {
          userid: userid,
          amount: amount,
          loanID: loanID,
          pin: pin,
          agentid: agentid
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const createLoanPaymentNew = async(userid, amount, loanID, pin, agentid, employerName, loanRefNo) => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "LoanDiskAddLoanRepaymentNew",
        dat: {
          userid: userid,
          amount: amount,
          loanID: loanID,
          pin: pin,
          agentid: agentid,
          employerName: employerName,
          loanRefNo: loanRefNo
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

export const uploadLoanFile = async(userid, imagedata, filename) => {
  try {
      const data = JSON.stringify({
        svc: "loandisk",
        pid: "uploadFile",
        dat: {
          userid: userid,
          imagedata: imagedata,
          filename: filename
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
};

// On interested in loan button click sendLoanInterestEmail is called.
export const sendLoanInterestEmail = async(fromEmailName, toEmail, emailSubject, emailText) => {
  try {
    const data = JSON.stringify({
      svc: "loandisk",
      pid: "SendEmailWithFrom2",
      dat: {
        fromEmailName: fromEmailName,
        destinationEmailAccount: toEmail,
        subject: emailSubject,
        emailText: emailText,
      },
    });

    
    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    
    const response = await axios(config);

    return response.data.data.header;
  } catch (error) {
    console.log(error);
  }
}